const template = () => {
	return {
		search: null,
		ref_mat: null,
		t_aux: null,
		has_rv: 0,
		asset_type_clean: null,
		babel_id: null,
		origin: 0,
		behive_category: null,
		has_proxy: 0,
		select: '0',
		ingest_date_after: null,
		ingest_date_before: null
	}
}

export const queryToFilters = (query) => {
	let filters = template()
	for (const key in query) {
		if (filters.hasOwnProperty(key)) {
			let value = query[key]
			if (key === 'has_rv' ||
					key === 'origin' ||
					key === 'has_proxy' ||
					key === 'babel_id') value = parseInt(value)
			filters[key] = value
		}
	}
	return filters
}

export const filtersToQuery = (filters) => {
	let temp = template()
	let query = {}
	for (const key in filters) {
		if (filters[key] !== temp[key] && filters[key]) {
			query[key] = filters[key]
		}
	}
	return query
}



// WEBPACK FOOTER //
// ./src/pages/filesystem/title_asset_finder_filters.js